'use strict';

window.TES = window.TES || {};

window.TES.favourite = (function() {

	var resourceId, $fave, user;

	var isFavourite = function() {
		if ($fave.hasClass('isFave')) {
			return true;
		}
		if ($fave.hasClass('notFave')) {
			return false;
		}
		return false;
	};

	var addOrRemoveFavourite = function(e) {
		e.preventDefault();
		if (!user.isAuthenticated()) {
			return false;
		}

		var addOrRemove = isFavourite() ? "remove" : "add";

        $.ajax({
            dataType: 'json',
			data: { item: resourceId },
            url: '/ResourcesHandler.ashx?favourite=' + addOrRemove,
            success: function(response) {
				if (response.valid) {
					$fave.toggleClass('isFave').toggleClass('notFave');
				}
			}
        });
		return true;
	};

    var initAuthenticatedUserState = function() {

		$fave.on('click', addOrRemoveFavourite);

		// get if resource is favourited
        $.getJSON('/favsfollowing/api/favourite/get?id=' + resourceId)
            .done(function (state) {
                state.Favourite ? $fave.addClass('isFave') : $fave.addClass('notFave');
            })
			.fail(function() {
				$fave.addClass('notFave');
			});

    };

    return {

        init: function() {
			resourceId = $('#resourceId').val();
			$fave = $('.fave');
            user = window.TES.user;

			if (user.isAuthenticated()) {
            	initAuthenticatedUserState();
			}
        }
    };
}());

$(function () {
    window.TES.favourite.init();
});
